/* DZ Runde 36: Steuerung des Cart-Drawers.
   Vanilla, kein Framework, keine Theme-Importe - laedt mit defer beim
   Seitenaufbau, nicht beim Oeffnen des Drawers.
   Jede Warenkorb-Aenderung geht ueber die Section-Rendering-API
   (Parameter "sections"), damit Kopf, Leiste, Liste und Footer in einer
   Antwort kommen und nichts nachgerechnet werden muss. */
(function () {
  "use strict";

  var RECS = "dz-cart-recs";
  var recsHtml = null;

  function drawer() {
    return document.querySelector("cart-drawer");
  }
  function sid() {
    var d = drawer();
    return d ? d.getAttribute("data-section-id") : null;
  }
  function body() {
    return document.querySelector("[data-dz-cart]");
  }

  /* Der Warenkorb-Zaehler in der Kopfleiste zaehlt weiter alles, der im
     Drawer nur Ware ohne Prio-Versand. Beide kommen deshalb aus ihrer
     eigenen Section - frueher kopierte das Skript die Drawer-Zahl nach
     oben, das wuerde jetzt die falsche Zahl in die Kopfleiste tragen. */
  function post(url, daten) {
    daten.sections = sid() + ",cart-icon-bubble";
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(daten)
    }).then(function (r) {
      return r.json().then(function (j) {
        return { ok: r.ok, daten: j };
      });
    });
  }

  /* Ganzen Drawer-Koerper aus der Section-Antwort ersetzen. Das deckt auch
     den Wechsel voll -> leer ab, den Teil-Anker nicht abbilden koennen. */
  function neuZeichnen(sections) {
    kopfleisteNachziehen(sections);
    var html = sections && sections[sid()];
    var ziel = body();
    if (!html || !ziel) return;
    var neu = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector("[data-dz-cart]");
    if (!neu) return;
    var warOffen = !!ziel.querySelector(".dz-cd__recs-panel.offen");
    ziel.innerHTML = neu.innerHTML;
    if (warOffen && recsHtml) recsEinsetzen(recsHtml, true);
  }

  /* Kopfleiste aus ihrer eigenen Section nachziehen. */
  function kopfleisteNachziehen(sections) {
    var html = sections && sections["cart-icon-bubble"];
    if (!html) return;
    var neu = new DOMParser().parseFromString(html, "text/html").querySelector("#cart-icon-bubble");
    if (!neu) return;
    ["#cart-icon-bubble", "#cart-icon-bubble-mobile"].forEach(function (s) {
      var n = document.querySelector(s);
      if (n) n.innerHTML = neu.innerHTML;
    });
  }

  function ansEnde() {
    var liste = document.querySelector(".dz-cd__liste");
    if (!liste) return;
    requestAnimationFrame(function () {
      liste.scrollTop = liste.scrollHeight;
    });
  }

  function sperren(el, an) {
    if (!el) return;
    if (an) el.setAttribute("aria-busy", "true");
    else el.removeAttribute("aria-busy");
  }

  /* --- Menge und Entfernen -------------------------------------------
     Runde 43: Die alte Fassung verwarf jeden Klick, solange eine
     Anfrage lief ("aria-busy"). Drei schnelle Klicks auf + ergaben
     deshalb 2 statt 4 - gemessen am 21.09.2026. Jetzt merkt sich jede
     Zeile ihren Zielwert, die Anzeige folgt sofort, und erst nach einer
     kurzen Ruhe geht EINE Anfrage mit dem Endwert raus. Laeuft gerade
     eine, wird der Nachzuegler danach geschickt. */
  var mengeZiel = {};
  var mengeTimer = {};
  var mengeLaeuft = {};

  function mengeSetzen(zeile, menge) {
    var key = zeile.getAttribute("data-dz-line");
    if (!key) return;
    if (menge < 0) menge = 0;
    mengeZiel[key] = menge;
    var wert = zeile.querySelector("[data-dz-menge-wert]");
    if (wert && menge > 0) wert.textContent = menge;
    clearTimeout(mengeTimer[key]);
    mengeTimer[key] = setTimeout(function () { mengeSenden(key); }, 280);
  }

  function mengeSenden(key) {
    if (mengeLaeuft[key]) return;
    if (!(key in mengeZiel)) return;
    var menge = mengeZiel[key];
    delete mengeZiel[key];
    mengeLaeuft[key] = true;
    var zeile = document.querySelector('[data-dz-line="' + key + '"]');
    sperren(zeile, true);
    post("/cart/change.js", { id: key, quantity: menge })
      .then(function (a) {
        if (a.ok) neuZeichnen(a.daten.sections);
        else nachladen();
      })
      .catch(nachladen)
      .finally(function () {
        mengeLaeuft[key] = false;
        sperren(document.querySelector('[data-dz-line="' + key + '"]'), false);
        /* Waehrend der Anfrage weitergeklickt? Dann gleich hinterher. */
        if (key in mengeZiel) mengeSenden(key);
      });
  }

  /* Notnagel: Section frisch holen, wenn eine Aenderung schiefging. */
  function nachladen() {
    var id = sid();
    if (!id) return;
    fetch(window.location.pathname + "?section_id=" + id)
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var o = {};
        o[id] = html;
        neuZeichnen(o);
      })
      .catch(function () {});
  }

  /* --- Empfehlungen: erst beim Aufklappen holen ----------------------- */
  function recsEinsetzen(html, still) {
    var panel = document.querySelector("[data-dz-recs-panel]");
    var knopf = document.querySelector("[data-dz-recs-toggle]");
    if (!panel || !knopf) return;
    panel.innerHTML = html;
    panel.classList.add("offen");
    knopf.setAttribute("aria-expanded", "true");
    if (!still) panel.scrollIntoView({ block: "nearest" });
  }

  function recsUmschalten(knopf) {
    var panel = document.querySelector("[data-dz-recs-panel]");
    if (!panel) return;
    if (panel.classList.contains("offen")) {
      panel.classList.remove("offen");
      knopf.setAttribute("aria-expanded", "false");
      return;
    }
    if (recsHtml) {
      recsEinsetzen(recsHtml);
      return;
    }
    knopf.setAttribute("aria-busy", "true");
    fetch(window.location.pathname + "?section_id=" + RECS)
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        recsHtml = html;
        recsEinsetzen(html);
      })
      .catch(function () {})
      .finally(function () {
        knopf.removeAttribute("aria-busy");
      });
  }

  /* --- Rabattcode ----------------------------------------------------- */
  var TEXT_KOMBI = "Dieser Code ist nicht mit dem 30%-Rabatt kombinierbar.";
  var TEXT_UNGUELTIG = "Dieser Code ist nicht gültig.";

  function fehlerZeigen(text) {
    var f = document.querySelector("[data-dz-code-fehler]");
    if (!f) return;
    f.textContent = text;
    f.classList.add("an");
  }

  function feldFuellen(code) {
    var f = document.querySelector("[data-dz-code]");
    if (f) f.value = code;
  }

  /* Laeuft der automatische 30-%-Rabatt gerade? Erst im Warenkorb
     nachsehen (Zeilen-Allocations), sonst das Liquid-Flag am Koerper. */
  function rabattAktiv(daten) {
    if (daten && daten.items) {
      for (var i = 0; i < daten.items.length; i++) {
        var a = daten.items[i].line_level_discount_allocations;
        if (a && a.length) return true;
      }
    }
    var k = body();
    return !!(k && k.getAttribute("data-dz-rabatt-aktiv") === "true");
  }

  /* Nur anwendbare Codes stehen im Markup - nicht anwendbare bleiben bei
     Shopify zwar am Warenkorb haengen, werden hier aber nicht gezeigt
     und beim naechsten Versuch mit weggeraeumt. */
  function aktiveCodes() {
    return [].map.call(document.querySelectorAll("[data-dz-code-weg]"), function (c) {
      return c.getAttribute("data-dz-code-weg");
    });
  }

  function codeAnwenden() {
    var feld = document.querySelector("[data-dz-code]");
    var fehler = document.querySelector("[data-dz-code-fehler]");
    if (!feld) return;
    var code = (feld.value || "").trim();
    if (fehler) fehler.classList.remove("an");
    if (!code) {
      fehlerZeigen("Bitte einen Code eingeben.");
      return;
    }
    var aktive = aktiveCodes();
    var knopf = document.querySelector("[data-dz-code-anwenden]");
    sperren(knopf, true);

    post("/cart/update.js", { discount: aktive.concat([code]).join(",") })
      .then(function (a) {
        var liste = (a.daten && a.daten.discount_codes) || [];
        var eintrag = null;
        for (var i = 0; i < liste.length; i++) {
          if (String(liste[i].code).toLowerCase() === code.toLowerCase()) eintrag = liste[i];
        }
        if (eintrag && eintrag.applicable === false) {
          /* Shopify laesst den nicht anwendbaren Code am Warenkorb
             kleben. Er wird hier gleich wieder abgeraeumt, sonst
             blockiert er den naechsten Versuch. */
          return post("/cart/update.js", { discount: aktive.join(",") }).then(function (b) {
            var daten = (b.ok && b.daten) ? b.daten : a.daten;
            if (b.ok && b.daten.sections) neuZeichnen(b.daten.sections);
            /* Erst NACH dem Neuzeichnen: der Re-Render ersetzt den
               Koerper und wuerde einen vorher gesetzten Text wegwerfen. */
            fehlerZeigen(rabattAktiv(daten) ? TEXT_KOMBI : TEXT_UNGUELTIG);
            feldFuellen(code);
          });
        }
        if (a.ok && a.daten.sections) neuZeichnen(a.daten.sections);
        else nachladen();
      })
      .catch(function () {
        fehlerZeigen("Code konnte nicht geprüft werden.");
        feldFuellen(code);
      })
      .finally(function () {
        sperren(document.querySelector("[data-dz-code-anwenden]"), false);
      });
  }

  /* Code entfernen: /cart/update.js bekommt die verbleibenden Codes.
     Bleibt keiner uebrig, geht ein leerer String raus - Shopify loescht
     damit alle Codes am Warenkorb. */
  function codeEntfernen(knopf) {
    var weg = knopf.getAttribute("data-dz-code-weg");
    var zeile = knopf.closest("[data-dz-code-ok]");
    if (zeile) sperren(zeile, true);
    var rest = [].map.call(document.querySelectorAll("[data-dz-code-weg]"), function (c) {
      return c.getAttribute("data-dz-code-weg");
    }).filter(function (c) { return c !== weg; });
    post("/cart/update.js", { discount: rest.join(",") })
      .then(function (a) {
        if (a.ok && a.daten.sections) neuZeichnen(a.daten.sections);
        else nachladen();
      })
      .catch(nachladen)
      .finally(function () { if (zeile) sperren(zeile, false); });
  }

  /* --- Prio-Versand: bestehende Mechanik, nur neue Optik -------------- */
  function prioSchalten(box) {
    var wrap = box.closest("[data-dz-prio]");
    if (!wrap) return;
    var vid = wrap.getAttribute("data-prio-variant-id");
    var an = box.checked;
    box.disabled = true;
    var arbeit;
    if (an) {
      arbeit = post("/cart/add.js", { items: [{ id: Number(vid), quantity: 1 }] });
    } else {
      arbeit = fetch("/cart.js")
        .then(function (r) {
          return r.json();
        })
        .then(function (c) {
          var z = c.items.filter(function (i) {
            return String(i.variant_id) === String(vid);
          })[0];
          if (!z) return { ok: true, daten: {} };
          return post("/cart/change.js", { id: z.key, quantity: 0 });
        });
    }
    arbeit
      .then(function (a) {
        if (a.ok && a.daten.sections) neuZeichnen(a.daten.sections);
        else nachladen();
        /* Die Prio-Zeile haengt unten an der Liste. Wird der Schalter
           angehakt, waere sie ohne diesen Sprung unter dem sichtbaren
           Rand entstanden - der Kunde saehe nur den Betrag steigen. */
        if (an) ansEnde();
      })
      .catch(function () {
        box.checked = !an;
        nachladen();
      });
  }

  /* --- ein Klick-Horcher fuer alles, ueberlebt jedes Neuzeichnen ------ */
  document.addEventListener("click", function (e) {
    var t = e.target;

    var recs = t.closest && t.closest("[data-dz-recs-toggle]");
    if (recs) {
      e.preventDefault();
      recsUmschalten(recs);
      return;
    }

    var menge = t.closest && t.closest("[data-dz-menge]");
    if (menge) {
      e.preventDefault();
      var zeile = menge.closest("[data-dz-line]");
      var wert = zeile && zeile.querySelector("[data-dz-menge-wert]");
      if (!zeile || !wert) return;
      var jetzt = parseInt(wert.textContent, 10) || 1;
      var neu = menge.getAttribute("data-dz-menge") === "plus" ? jetzt + 1 : jetzt - 1;
      if (neu < 0) neu = 0;
      mengeSetzen(zeile, neu);
      return;
    }

    var weg = t.closest && t.closest("[data-dz-entfernen]");
    if (weg) {
      e.preventDefault();
      var z2 = weg.closest("[data-dz-line]");
      if (z2) mengeSetzen(z2, 0);
      return;
    }

    if (t.closest && t.closest("[data-dz-code-anwenden]")) {
      e.preventDefault();
      codeAnwenden();
      return;
    }

    var codeWeg = t.closest && t.closest("[data-dz-code-weg]");
    if (codeWeg) {
      e.preventDefault();
      codeEntfernen(codeWeg);
      return;
    }

    if (t.closest && t.closest("[data-dz-weiter]")) {
      e.preventDefault();
      var zu = document.querySelector(".dz-cd__zu");
      if (zu) zu.click();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Enter") return;
    if (e.target && e.target.matches && e.target.matches("[data-dz-code]")) {
      e.preventDefault();
      codeAnwenden();
    }
  });

  document.addEventListener("change", function (e) {
    if (e.target && e.target.id === "dz-prio-check") prioSchalten(e.target);
  });
})();
